import styled from "styled-components";

export const OptInWinHighlightLabelDefaultBox = styled.div`
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 1;
    font-stretch: extra-condensed;
    text-align: center;
    text-transform: uppercase;
    text-wrap: nowrap;
    color: #fff;
`;